import { useFormContext } from 'react-hook-form';
import { NetworkDetailsFormValues, NetworkNodeFieldPath } from '../types';
import { TabScreens } from './NetworkSetup';

interface ScreensSidebarProps {
  selectedTab: TabScreens;
  selectedFieldPath: NetworkNodeFieldPath;
  handleTabChange: (tab: TabScreens) => void;
}

export const SIDEBAR_TABS: { id: TabScreens; label: string; field?: string, required?: boolean}[] =
  [
    { id: 'departments', label: 'הגדרת מחלקות', field: 'departments', required: true },
    { id: 'roles', label: 'תפקידים והרשאות', field: 'roles', required: true },
    { id: 'shifts', label: 'הגדרת משמרות', field: 'shifts', required: true },
    { id: 'zones', label: 'הגדרת אזורים', field: 'zones', required: true },
    { id: 'users', label: 'הגדרת משתמשים', field: 'users' },
    { id: 'checklists', label: "הוספת צ'קליסטים", field: 'checklists' },
    { id: 'regulations', label: 'הוספת רגולציה', field: 'regulations' },
  ];

function getAtPath(obj: any, path: string): any {
  return path.split('.').reduce((acc, k) => acc?.[isNaN(+k) ? k : +k], obj);
}

function hasErrors(obj: any): boolean {
  if (!obj) return false;
  if (Array.isArray(obj)) return obj.some((v) => v && hasErrors(v));
  if (typeof obj === 'object')
    return 'message' in obj
      ? !!obj.message
      : Object.values(obj).some((v) => v && hasErrors(v));
  return false;
}

function ScreensSidebar({
  selectedTab,
  selectedFieldPath,
  handleTabChange,
}: ScreensSidebarProps) {
  const {
    watch,
    formState: { errors },
  } = useFormContext<NetworkDetailsFormValues>();
  const node = (watch(selectedFieldPath as any) as any) ?? {};
  const nodeErrors = getAtPath(errors, selectedFieldPath as string) ?? {};

  return (
    <div className="w-[200px] h-full flex flex-col gap-1 overflow-y-auto border border-gray70 rounded-tl-lg rounded-tr-lg p-2">
      {SIDEBAR_TABS.map((tab) => {
        const isActive = selectedTab === tab.id;

        const count = tab.field ? ((node[tab.field] as any[])?.length ?? 0) : 0;
        const tabHasError = tab.field
          ? hasErrors(nodeErrors[tab.field])
          : false;
        const showCount = count > 0 && !tabHasError;
        const showValidationDot =  tab.required && (tabHasError || count === 0);

        return (
          <div
            key={tab.id}
            className={`w-full px-3 py-3 text-right rounded-lg flex items-center justify-between gap-2 cursor-pointer ${
              isActive ? 'bg-pastelBlue' : ''
            }`}
            onClick={() => handleTabChange(tab.id)}
          >
            <span className={`text-base flex items-center gap-1.5 ${showValidationDot ? "text-raspberryRed" : "text-black"}`}>
              {tab.label}
              {showCount && (
                <span className="text-sm text-darkerGray ms-1">({count})</span>
              )}
              {showValidationDot && (
                <span
                  className="w-[14px] h-[14px] rounded-full bg-raspberryRed shrink-0"
                  aria-label="שדה חובה חסר"
                />
              )}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default ScreensSidebar;
